import Abstract from './abstract';

export default class Smart extends Abstract {
  constructor() {
    super();
    this._event = {};
  }

  updateData(update, justDataUpdating) {
    if (!update) {
      return;
    }

    this._event = Object.assign(
      {},
      this._event,
      update,
    );

    if (justDataUpdating) {
      return;
    }

    this.updateElement();
  }

  updateElement() {
    const prevElement = this.getElement();
    const parent = prevElement.parentElement;
    this.removeElement();

    const newElement = this.getElement();

    parent.replaceChild(newElement, prevElement);

    this.restoreHandlers();
  }

  restoreHandlers() {
    throw new Error('Abstract method not implemented: resetHandlers');
  }
}
